import { NavLink, Outlet } from 'react-router-dom';
import Header from '../components/header/Header';
import Footer from '../components/footer/Footer';
import styles from './RootLayout.module.scss'
import ScrollToTop from '../components/ScrollToTop';

export default function RootLayout() {
  return (
    <div className={styles.rootLayout}>
      <ScrollToTop>
        <Header />

        <main>
          <Outlet />
        </main>

        <Footer />
      </ScrollToTop>

    </div>
  )
}
